import { standardViews } from './viewLabel';

/**
 * Чи активне подання — власне (не одне зі стандартних подань рушія): власні подання пакета (rt.views.custom, аналітика) та заглушка
 * невідомого ключа вантажать дані самі, тож сторінка списку з фасетами, пагінація й масові дії їм не потрібні. Чиста функція.
 */
export function isCustomView(view: string): boolean {
  return !(standardViews as readonly string[]).includes(view);
}
